import { ClassThemeProvider } from '@class-ui/theme';

import ReportProblemContainer from './ReportProblemContainer';
import ReportProblemForm from './ReportProblemForm';

const ReportProblemModal = () => (
    <ClassThemeProvider>
        <ReportProblemContainer.Provider>
            <ReportProblemForm />
        </ReportProblemContainer.Provider>
    </ClassThemeProvider>
);

export default ReportProblemModal;
